import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import filter from 'lodash/filter';
import { ReactComponent as WarnRedIcon } from '../../../images/warn_red.svg';
import { ReactComponent as WarnYellowIcon } from '../../../images/warn_yellow.svg';
import { ReactComponent as NotAuthIcon } from '../../../images/not_auth.svg';
import { ReactComponent as Key } from '../../../images/key_green.svg';

function HeaderLinks({ users, expired, getUsers, total}) {
  const [all, setAll] = useState(0);
  const [expire, setExpire] = useState(0);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (all === 0) {
      setAll(users.length);
      setExpire(filter(users, (item) => item.boxes_expired !== 0).length);
      setActive(filter(users, (item) => !item.authorized).length);
    }
  }, [users]);

  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between">
      <div className="flex">
        <div>
          <Button
            onClick={() => {
              getUsers({
                role: 'client',
              });
            }}
            className="text-20 pl-0  text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">
              {t('all')} {`(${total})`}
            </span>
          </Button>
        </div>
        <div>
          <Button
            onClick={() => {
              getUsers({
                has_boxes_expired: 1,
                role: 'client',
              });
            }}
            className="text-20  text-red flex items-center hover:text-red"
            type="link"
          >
            <WarnRedIcon className="mr-10" />
            <span className="border-b-1 border-dotted">
              {t('latePay')} {`(${expire})`}
            </span>
          </Button>
        </div>
        <div>
          <Button
            onClick={() => {
              getUsers({
                has_boxes_expire_in: 7,
                role: 'client',
              });
            }}
            className="text-20  text-yellow flex items-center hover:text-yellow"
            type="link"
          >
            <WarnYellowIcon className="mr-10" />
            <span className="border-b-1 border-dotted">
              {t('timeEnd')} {`(${expired})`}
            </span>
          </Button>
        </div>
        <div>
          <Button
            onClick={() => {
              getUsers({
                authorized: 0,
                role: 'client',
              });
            }}
            type="link"
            className="text-20 text-graytext flex items-center hover:text-graytext"
          >
            <NotAuthIcon className="mr-10" />
            <span className="border-b-1 border-dotted">
              {' '}
              {t('falseAuth')} {`(${active})`}
            </span>
          </Button>
        </div>
        <div>
          <Button
            onClick={() => {
              getUsers({
                role: 'client',
                parent_id__is_null: 0,
              });
            }}
            type="link"
            className="text-20  flex items-center"
          >
            <span className="border-b-1 border-dotted">{t('daughters')}</span>
          </Button>
        </div>
      </div>
      <div className="flex justify-end">
        <Button
          type="link"
          className="text-14 p-0 text-green flex items-center hover:text-green"
        >
          <Key className="mr-10" />
          <span className="border-b-1 border-dotted">
            {' '}
            {t('authAll')} {`(${active})`}
          </span>
        </Button>
      </div>
    </div>
  );
}

HeaderLinks.propTypes = {};

export default HeaderLinks;
